import { apiCall } from "./common/base.service"
import config from "../config/application"
import permission from "./permissions.service"
import dictionary from "../config/dictionary"
//url
const findData = "/find"
const save_material = "/register"
const delete_material = "/delete"
const update_material = "/update"
const massive_charge = "/save-massive"

class MaterialSupplierService {
  async getMaterialListService(data) {
    const url = `${config.data.providers.materialSupplier.url}${findData}`
    const userAux = JSON.parse(sessionStorage.getItem("user"))
    const validPermission = await materialSupplierService.getPermissions(
      userAux.id.user.username,
      dictionary.configApp.action.list
    )
    const error = validPermission?.response?.data?.error
    return error ? validPermission : apiCall("post", url, data)
  }

  async saveMaterial(json) {
    const url = `${config.data.providers.materialSupplier.url}${save_material}`
    const userAux = JSON.parse(sessionStorage.getItem("user"))
    const validPermission = await materialSupplierService.getPermissions(
      userAux.id.user.username,
      dictionary.configApp.action.add
    )
    const error = validPermission?.response?.data?.error
    return error ? validPermission : apiCall("post", url, json)
  }
  async deleteMaterial(files) {
    const url = `${config.data.providers.materialSupplier.url}${delete_material}`
    const userAux = JSON.parse(sessionStorage.getItem("user"))
    const validPermission = await materialSupplierService.getPermissions(
      userAux.id.user.username,
      dictionary.configApp.action.delete
    )
    const error = validPermission?.response?.data?.error
    return error ? validPermission : apiCall("delete", url, files)
  }

  async updateMaterial(file) {
    const url = `${config.data.providers.materialSupplier.url}${update_material}`
    const userAux = JSON.parse(sessionStorage.getItem("user"))
    const validPermission = await materialSupplierService.getPermissions(
      userAux.id.user.username,
      dictionary.configApp.action.edit
    )
    const error = validPermission?.response?.data?.error
    return error ? validPermission : apiCall("put", url, file)
  }
  async saveMassiveCharge(json) {
    const url = `${config.data.providers.materialSupplier.url}${massive_charge}`
    const userAux = JSON.parse(sessionStorage.getItem("user"))
    const validPermission = await materialSupplierService.getPermissions(
      userAux.id.user.username,
      dictionary.configApp.action.add
    )
    const error = validPermission?.response?.data?.error
    return error ? validPermission : apiCall("post", url, json)
  }
  getPermissions = (username, action) => {
    return permission.validPermission(
      process.env.REACT_APP_TRANSACTION_MATERIAL_SUPPLIER,
      username,
      process.env.REACT_APP_SYSTEM_CODE,
      action
    )
  }
}

const materialSupplierService = new MaterialSupplierService()
export default materialSupplierService
